import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { normalizarValorOrdenacao } from '../../../shared/helpers/ordenacao-tabela.helper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { TipoContatoEnum } from '@shared/enums/pessoa/tipo-contato.enum';
import { VendaTipoDocumentoEnum } from '@shared/enums/vendas/venda-tipo-documento.enum';
import {
    OportunidadesClienteDialogComponent,
    OportunidadesClienteDialogData,
} from '@shared/components/oportunidades-cliente-dialog/oportunidades-cliente-dialog.component';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { GetAllPessoaResponse } from '../../../shared/services/responses/pessoa/get-all-pessoa.response';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { PessoaService } from '../../../shared/services/apis/pessoa/pessoa.service';
import { PessoaLookupService } from '../../../shared/services/apis/pessoa/pessoa-lookup.service';
import { PessoaMassActionRequest } from '../../../shared/services/requests/pessoa/pessoa-mass-action.request';
import { PessoaListStruct } from '../../../shared/services/structs/pessoa/pessoa-list.struct';
import { PessoaListaRequest } from '../../../shared/services/requests/pessoa/pessoa-lista.request';
import { ImpressaoListaSimplesComponent } from './dialogs/impressao-lista-simples/impressao-lista-simples.component';
import { ImpressaoListaAgrupadaComponent } from './dialogs/impressao-lista-agrupada/impressao-lista-agrupada.component';
import { ImpressaoAniversariantesComponent } from './dialogs/impressao-aniversariantes/impressao-aniversariantes.component';
import { DialogAlterarStatusMassaComponent } from './dialogs/alterar-status-massa/dialog-alterar-status-massa.component';
import { DialogVincularVendedorComponent } from './dialogs/vincular-vendedor/dialog-vincular-vendedor.component';
import { DialogImportarPessoasComponent } from './dialogs/importar-pessoas/dialog-importar-pessoas.component';
import {
    UltimasVendasDialogComponent,
    UltimasVendasDialogData,
} from '@shared/components/ultimas-vendas-dialog/ultimas-vendas-dialog.component';
import {
    UltimasComprasDialogComponent,
    UltimasComprasDialogData,
} from '@shared/components/ultimas-compras-dialog/ultimas-compras-dialog.component';
import { environment } from '../../../../environments/environment';
import { PessoaListaRefinamentoEnum } from '../../../shared/enums/pessoa/pessoa-lista-refinamento.enum';
import { ExtracaoDadosData, ExtracaoDadosModalComponent, FiltroExtracao } from '../../../shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { OrigemPedidoExportacaoEnum } from '../../../shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { UnidadeFederativaService } from '../../../shared/services/apis/usuario/unidade-federativa.service';

import { MatSort, MatSortModule } from '@angular/material/sort';
import { ViewChild } from '@angular/core';
import { UtilService } from '../../../shared/services/util.service';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';

@Component({
    selector: 'app-pessoa-lista',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatTooltipModule,
        MatSelectModule,
        EmptyListComponent,
        SelectPesquisavelComponent,
        RouterModule,
        MatSortModule,
        HeaderComponent,
        LoadingBoxDefaultListComponent
    ],
    templateUrl: './pessoa-lista.component.html',
    styleUrl: './pessoa-lista.component.css'
})
export class PessoaListaComponent implements OnInit {

    // Enums para Menu e Permissões
    public moduloEnum = ModuloEnum.Cadastros;
    public funcionalidadeEnum = FuncionalidadeEnum.Cadastros_Pessoas;

    public model: FormGroup;
    public _isLoading: boolean = false;
    public filtroRefinar: number | null;
    public _pessoaListaRefinamentoEnum = PessoaListaRefinamentoEnum;
    public _isLoadingDownloadAll: boolean = false;
    public _tipoExtracaoEnum = TipoExtracaoEnum;
    public vendedorSelecionado: any = null;
    public municipioSelecionado: any = null;

    // URLs e Listas para Filtros Avançados
    public get urlMunicipio(): string {
        return `${environment.urlApiUsuario}Municipio/select?idUnidadeFederativa=${this.model?.get('idUf')?.value ?? 0}`;
    }
    public urlVendedor = `${environment.urlApiPessoa}Lookup/listVendedorSelect`;
    public listaUf: any[] = [];
    public listaTipoContato: any[] = [];
    public loadLookups: boolean = false;

    // Dados e Paginação
    public _listaPessoaResponse: GetAllPessoaResponse | undefined;
    public _dataSource = new MatTableDataSource<PessoaListStruct>();
    public _paginaAtual: number = 0;
    public _ultimaPagina: boolean = false;

    // Colunas do Grid
    public displayedColumns: string[] = [
        'select',
        'nome',
        'documento',
        'contato',
        'tipo_contato',
        'status',
        'actions'
    ];

    // Controle de Seleção (Checkboxes)
    public selection = new SelectionModel<PessoaListStruct>(true, []);

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this._dataSource.sort = sort;
        this._dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'documento': return normalizarValorOrdenacao(item.cpfFormatado || item.cnpjFormatado || item.documentoEstrangeiro || '');
                case 'contato': return normalizarValorOrdenacao(`${item.emailNFe || ''} ${item.telefoneFormatado || ''}`.trim());
                case 'tipo_contato': return normalizarValorOrdenacao(item.listTipoContato && item.listTipoContato.length > 0 ? item.listTipoContato.join(', ') : '');
                case 'status': return normalizarValorOrdenacao(item.isAtivo ? '1' : '0'); // Sort boolean as string or number
                default: return normalizarValorOrdenacao((item as any)[property]);
            }
        };
    }

    constructor(
        private formBuilder: FormBuilder,
        private pessoaService: PessoaService,
        private pessoaLookupService: PessoaLookupService,
        private alertService: AlertService,
        private dialog: MatDialog,
        private utilService: UtilService,
        private unidadeFederativaService: UnidadeFederativaService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.model = this.formBuilder.group({
            pesquisa: [''],
            // Filtros Avançados
            idVendedor: [null],
            idUf: [null],
            idMunicipio: [{ value: null, disabled: true }],
            idTipoContato: [null]
        });

        this.carregarLookups();
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, ['/cadastros/pessoas/cadastrar']);
    }

    private loadFilters() {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (filtroSalvo) {
            this.model.patchValue(filtroSalvo);
            this.atualizarEstadoMunicipio(filtroSalvo.idUf ?? null, false);
        }
    }


    private carregarLookups(): void {
        this.loadLookups = true;
        this.pessoaLookupService.getLookup().subscribe({
            next: (res) => {
                if (!res.isError) {
                    this.listaTipoContato = res.listaTipoContato;
                }
                this.loadLookups = false;
                this.loadFilters();
                this.pesquisar();
            }
        });
        this.unidadeFederativaService.getUnidadesFederativas().subscribe(lista => {
            this.listaUf = lista.map(x => ({
                id: x.idUnidadeFederativa,
                descricao: x.descricaoExibicao,
                codigo: x.id,
            }));
        });
    }

    // --- Lógica de Pesquisa e Paginação ---

    public pesquisar(): void {
        if (this._isLoading) return;

        this._isLoading = true;

        // request object
        const request = this.getFiltrosRequest();

        if (this.filtroRefinar) {
            request.idPessoaListaRefinamento = this.filtroRefinar;
        }

        this.pessoaService.getAll(request, this._paginaAtual).subscribe({
            next: (response: GetAllPessoaResponse) => {
                this._isLoading = false;

                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    return;
                }

                if (!this._listaPessoaResponse) {
                    this._listaPessoaResponse = response;
                    this._dataSource.data = response.listPessoas;
                } else {
                    this._listaPessoaResponse.listPessoas.push(...response.listPessoas);
                    this._dataSource.data = this._listaPessoaResponse.listPessoas;
                }

                this._ultimaPagina = !response.listPessoas?.length ||
                    this._dataSource.data.length >= response.fullListSize;
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    public clickPesquisar(): void {
        this._paginaAtual = 0;
        this._listaPessoaResponse = undefined;
        this._dataSource.data = [];
        this._ultimaPagina = false;
        this.selection.clear();
        this.pesquisar();
    }

    // Método chamado pelo botão "Aplicar" do menu
    public aplicarFiltros(): void {
        this.clickPesquisar();
    }

    public proximaPagina(): void {
        this._paginaAtual++;
        this.pesquisar();
    }

    public limparFiltros(): void {
        this.model.patchValue({
            pesquisa: '',
            idVendedor: null,
            idUf: null,
            idMunicipio: null,
            idTipoContato: null
        });
        this.vendedorSelecionado = null;
        this.municipioSelecionado = null;
        this.model.get('idMunicipio')?.disable({ emitEvent: false });
        this.filtroRefinar = null;
        this.clickPesquisar();
    }

    // --- Lógica de Seleção (Checkbox) ---

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this._dataSource.data.length;
        return numSelected === numRows && numRows > 0;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        this.selection.select(...this._dataSource.data);
    }

    checkboxLabel(row?: PessoaListStruct): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.idPessoa}`;
    }

    // --- Ações (Top Menu) ---

    public getFiltrosRequest(): PessoaListaRequest {
        const request = new PessoaListaRequest();
        request.searchText = this.model.get('pesquisa')?.value;
        request.idVendedor = this.model.get('idVendedor')?.value;
        request.idUnidadeFederativa = this.model.get('idUf')?.value;
        request.idMunicipio = this.model.get('idMunicipio')?.value;
        request.idTipoContato = this.model.get('idTipoContato')?.value;

        if (this.filtroRefinar) {
            request.idPessoaListaRefinamento = this.filtroRefinar;
        }
        return request;
    }

    public imprimir(): void {
        this.dialog.open(ImpressaoListaSimplesComponent, {
            data: {
                filtros: this.getFiltrosRequest()
            },
            maxWidth: '90vw',
            disableClose: false
        });
    }

    public imprimirAgrupado(): void {
        this.dialog.open(ImpressaoListaAgrupadaComponent, {
            data: {
                filtros: this.getFiltrosRequest()
            },
            maxWidth: '90vw',
            disableClose: false
        });
    }

    public listarAniversariantes(): void {
        this.dialog.open(ImpressaoAniversariantesComponent, {
            data: {
                filtros: this.getFiltrosRequest()
            },
            maxWidth: '90vw',
            disableClose: false
        });
    }

    public importar(): void {
        const dialogRef = this.dialog.open(DialogImportarPessoasComponent, {
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.clickPesquisar();
            }
        });
    }

    // --- Ações (Bulk) ---

    public alterarStatusEmMassa(): void {
        const dialogRef = this.dialog.open(DialogAlterarStatusMassaComponent, {

        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== null) {
                this.processarMassAction(this.selection.selected, null, result);
            }
        });
    }

    public vincularVendedorEmMassa(): void {
        const dialogRef = this.dialog.open(DialogVincularVendedorComponent, {

        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.processarMassAction(this.selection.selected, result, null);
            }
        });
    }

    // --- Ações (Excluir) ---

    public abrirModalExcluir(pessoa?: PessoaListStruct): void {
        const isLote = !pessoa;
        const listaParaExcluir = isLote ? this.selection.selected : [pessoa!];

        if (listaParaExcluir.length === 0) {
            this.alertService.show('Atenção', 'Nenhuma pessoa selecionada.', AlertType.warning);
            return;
        }

        const descricao = isLote
            ? `Confirma a exclusão de ${listaParaExcluir.length} contatos selecionados?`
            : `Deseja excluir ${pessoa?.nome}?`;

        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Confirmação de Exclusão',
                description: descricao,
                buttonConfirm: 'Confirmar',
                buttonClose: 'Cancelar',
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm) {
                this.processarExclusao(listaParaExcluir);
            }
        });
    }

    private processarExclusao(lista: PessoaListStruct[]): void {
        this._isLoading = true;
        const total = lista.length;

        var listIdPessoa: number[] = lista.map(x => x.idPessoa);
        if (lista.length > 0) {
            this.pessoaService.excluirMultiplos(listIdPessoa).subscribe({
                next: (res) => {
                    this._isLoading = false;
                    if (res.isError) {
                        this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                        return;
                    }
                    this.alertService.show('Sucesso', 'Exclusão realizada.', AlertType.success);
                    this.clickPesquisar();
                },
                error: (err) => {
                    this._isLoading = false;
                    this.alertService.show('Erro', 'Falha ao excluir.', AlertType.error);
                }
            })
        }
    }

    private processarMassAction(lista: PessoaListStruct[], idVendedor: number | null, isAtivo: boolean | null): void {
        this._isLoading = true;
        const total = lista.length;

        var listIdPessoa: number[] = lista.map(x => x.idPessoa);

        var pessoaMassActionRequest = new PessoaMassActionRequest();
        pessoaMassActionRequest.listIdPessoa = listIdPessoa;
        pessoaMassActionRequest.idVendedor = idVendedor;
        pessoaMassActionRequest.isAtivo = isAtivo;

        if (lista.length > 0) {
            this.pessoaService.massAction(pessoaMassActionRequest).subscribe({
                next: (res) => {
                    this._isLoading = false;
                    if (res.isError) {
                        this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    }

                    this.clickPesquisar();
                },
                error: (err) => {
                    this._isLoading = false;
                    this.alertService.show('Erro', 'Falha ao realizar mass action.', AlertType.error);
                }
            })
        }
    }

    // --- Helpers de Template ---

    getTipoContatoLabel(pessoa: PessoaListStruct): string {
        if (pessoa.listTipoContato && pessoa.listTipoContato.length > 0) {
            return pessoa.listTipoContato.join(', ');
        }
        return '-';
    }

    // Motivo de as ações de CRM ficarem indisponíveis (PA-01); vazio = habilitadas.
    getMotivoCrmIndisponivel(listIdTipoContato: number[]): string {
        const ids = listIdTipoContato ?? [];
        if (!ids.length || !ids.every(id => id === TipoContatoEnum.Fornecedor || id === TipoContatoEnum.Transportadora)) {
            return '';
        }
        const isFornecedor = ids.includes(TipoContatoEnum.Fornecedor);
        const isTransportadora = ids.includes(TipoContatoEnum.Transportadora);
        const quem = isFornecedor && isTransportadora ? 'fornecedor e transportadora' : isFornecedor ? 'fornecedor' : 'transportadora';
        return `Pessoa cadastrada só como ${quem}. Oportunidades no CRM são para clientes: inclua o tipo Cliente no cadastro para usar.`;
    }

    abrirOportunidadesCrm(pessoa: PessoaListStruct): void {
        const data: OportunidadesClienteDialogData = {
            idPessoaCliente: pessoa.idPessoa,
            nomeCliente: pessoa.nome,
            titulo: 'Oportunidades no CRM',
            origem: 'pessoa'
        };
        this.dialog.open(OportunidadesClienteDialogComponent, {
            width: '1040px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            autoFocus: false,
            data
        });
    }

    incluirOportunidadeCrm(pessoa: PessoaListStruct): void {
        this.router.navigate(['/vendas/crm'], {
            queryParams: { novaOportunidadeIdPessoaCliente: pessoa.idPessoa, origemNovaOportunidade: 'pessoa' }
        });
    }

    // Motivo de orçamento e pedido ficarem indisponíveis (PA-02): só para quem não é Cliente; vazio = habilitados.
    getMotivoOrcamentoPedidoIndisponivel(listIdTipoContato: number[]): string {
        const ids = listIdTipoContato ?? [];
        if (!ids.length || ids.includes(TipoContatoEnum.Cliente)) return '';
        const isFornecedor = ids.includes(TipoContatoEnum.Fornecedor);
        const isTransportadora = ids.includes(TipoContatoEnum.Transportadora);
        const quem = isFornecedor && isTransportadora ? 'fornecedor e transportadora' : isFornecedor ? 'fornecedor' : 'transportadora';
        return `Pessoa cadastrada só como ${quem}. Orçamentos e pedidos de venda são para clientes: `
            + 'inclua o tipo Cliente no cadastro para usar.';
    }

    // Motivo de "Criar nota fiscal" ficar indisponível (PA-02); vazio = habilitada.
    getMotivoNotaFiscalIndisponivel(listIdTipoContato: number[]): string {
        const ids = listIdTipoContato ?? [];
        if (ids.includes(TipoContatoEnum.Transportadora)
            && !ids.includes(TipoContatoEnum.Cliente) && !ids.includes(TipoContatoEnum.Fornecedor)) {
            return 'Transportadora não recebe nota fiscal. Inclua o tipo Cliente ou Fornecedor no cadastro para emitir.';
        }
        return '';
    }

    incluirOrcamento(pessoa: PessoaListStruct): void {
        this.router.navigate(['/vendas/processo-venda/documento'], {
            queryParams: { tipo: VendaTipoDocumentoEnum.Orcamento, idPessoaCliente: pessoa.idPessoa }
        });
    }

    criarPedidoVenda(pessoa: PessoaListStruct): void {
        this.router.navigate(['/vendas/processo-venda/documento'], {
            queryParams: { tipo: VendaTipoDocumentoEnum.PedidoDeVenda, idPessoaCliente: pessoa.idPessoa }
        });
    }

    criarNotaFiscal(pessoa: PessoaListStruct): void {
        this.router.navigate(['/vendas/nota-fiscal-saida/documento'], {
            queryParams: { idPessoaDestinatario: pessoa.idPessoa }
        });
    }

    abrirUltimasVendas(pessoa: PessoaListStruct): void {
        const data: UltimasVendasDialogData = { idPessoa: pessoa.idPessoa, nomePessoa: pessoa.nome };
        this.dialog.open(UltimasVendasDialogComponent, {
            width: '1040px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            height: '90vh',
            autoFocus: false,
            data
        });
    }

    abrirUltimasCompras(pessoa: PessoaListStruct): void {
        const data: UltimasComprasDialogData = { idPessoa: pessoa.idPessoa, nomePessoa: pessoa.nome };
        this.dialog.open(UltimasComprasDialogComponent, {
            width: '1040px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            height: '90vh',
            autoFocus: false,
            data
        });
    }

    getStatusLabel(isAtivo: boolean): string {
        return isAtivo ? 'Ativo' : 'Inativo';
    }

    getStatusClass(isAtivo: boolean): string {
        return isAtivo ? 'badge-verde' : 'badge-cinza';
    }

    changeCidade(item: any) {
        this.municipioSelecionado = item;
        if (item?.idUnidadeFederativa) {
            this.model.get('idUf')?.patchValue(item.idUnidadeFederativa);
        }
    }

    changeUf(item: any): void {
        this.atualizarEstadoMunicipio(item?.id ?? null);
    }

    private atualizarEstadoMunicipio(idUf: number | null, limpar: boolean = true): void {
        const municipioControl = this.model.get('idMunicipio');

        if (limpar) {
            municipioControl?.setValue(null);
            this.municipioSelecionado = null;
        }

        if (idUf) municipioControl?.enable({ emitEvent: false });
        else municipioControl?.disable({ emitEvent: false });
    }

    changeVendedor(item: any) {
        this.vendedorSelecionado = item;
    }

    getLabelRefinamento(valor: number): string {
        switch (valor) {
            case this._pessoaListaRefinamentoEnum.nome: return 'Nome';
            case this._pessoaListaRefinamentoEnum.email: return 'E-mail';
            case this._pessoaListaRefinamentoEnum.documento: return 'Documento';
            case this._pessoaListaRefinamentoEnum.telefone: return 'Telefone';
            default: return 'Outro';
        }
    }

    fazerPedidoExtracao(idTipoExtracao: number, $event: any): void {
        if (this._isLoadingDownloadAll) return;
        $event.stopPropagation();

        const titulo = 'Exportação de Pessoas'; // Ou use lógica dinâmica se preferir

        const formValue = this.model.getRawValue();
        const filtrosMapeados: FiltroExtracao[] = [];

        // 1. Pesquisa Texto
        if (formValue.pesquisa) {
            filtrosMapeados.push({
                label: 'Pesquisa',
                formControlName: 'searchText',
                valor: formValue.pesquisa
            });
        }

        // 2. Refinamento (se existir)
        if (this.filtroRefinar) {
            // Função auxiliar simples para pegar o label do enum, se quiser pode criar um método separado
            let labelRefinamento = 'Outro';
            if (this.filtroRefinar === this._pessoaListaRefinamentoEnum.nome) labelRefinamento = 'Nome';
            else if (this.filtroRefinar === this._pessoaListaRefinamentoEnum.email) labelRefinamento = 'E-mail';
            else if (this.filtroRefinar === this._pessoaListaRefinamentoEnum.documento) labelRefinamento = 'Documento';
            else if (this.filtroRefinar === this._pessoaListaRefinamentoEnum.telefone) labelRefinamento = 'Telefone';

            filtrosMapeados.push({
                label: 'Refinar por',
                formControlName: 'idPessoaListaRefinamento',
                valor: this.filtroRefinar,
                valorExibicao: labelRefinamento
            });
        }

        // 3. Vendedor (AGORA COM NOME)
        if (formValue.idVendedor) {
            filtrosMapeados.push({
                label: 'Vendedor', // Removemos o "(ID)"
                formControlName: 'idVendedor',
                valor: formValue.idVendedor,
                // Usa a descrição do objeto salvo ou fallback para o ID
                valorExibicao: this.vendedorSelecionado ? this.vendedorSelecionado.descricao : formValue.idVendedor
            });
        }

        // 4. Município (AGORA COM NOME)
        if (formValue.idMunicipio) {
            filtrosMapeados.push({
                label: 'Município',
                formControlName: 'idMunicipio',
                valor: formValue.idMunicipio,
                valorExibicao: this.municipioSelecionado ? this.municipioSelecionado.descricao : formValue.idMunicipio
            });
        }

        // 5. UF
        if (formValue.idUf) {
            const uf = this.listaUf.find(u => u.id === formValue.idUf);
            filtrosMapeados.push({
                label: 'UF',
                formControlName: 'idUnidadeFederativa',
                valor: formValue.idUf,
                valorExibicao: uf ? uf.descricao : formValue.idUf
            });
        }

        // 6. Tipo de Contato
        if (formValue.idTipoContato) {
            const tipo = this.listaTipoContato.find(t => t.id === formValue.idTipoContato);
            filtrosMapeados.push({
                label: 'Tipo de Contato',
                formControlName: 'idTipoContato',
                valor: formValue.idTipoContato,
                valorExibicao: tipo ? tipo.descricao : formValue.idTipoContato
            });
        }

        const dialogData: ExtracaoDadosData = {
            titulo: titulo,
            tipoExtracao: idTipoExtracao,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.CadastrosPessoas,
            filtros: filtrosMapeados,
            possuiAutomacao: false,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            panelClass: 'extracao-dados-panel',
            disableClose: true,
        });
    }

    get qtdFiltrosAvancados(): number {
        let count = 0;
        const formValue = this.model.getRawValue();

        if (formValue.idVendedor) count++;
        if (formValue.idUf) count++;
        if (formValue.idMunicipio) count++;
        if (formValue.idTipoContato) count++;

        return count;
    }
}
